export const UPDATE_FILTER = "UPDATE_FILTER";
export const API_STATUS_MASTER = "API_STATUS_MASTER";
export const GET_BATCH_DATA="GET_BATCH_DATA"
export const API_STATUS_MASTER_DATA="API_STATUS_MASTER_DATA"

export const API_STATUS = "API_STATUS";
export const CLEAR_API_STATUS="CLEAR_API_STATUS"
export const PDF_AND_PAGE_DETAILS = "PDF_AND_PAGE_DETAILS";
export const GET_VALI_DATA = "GET_VALI_DATA";
export const VALIDATE_USER_STATUS = "VALIDATE_USER_STATUS";
export const IS_SIGNATURE_UPLOADED_STATUS = "IS_SIGNATURE_UPLOADED_STATUS";
